import {OfferType} from "../../offer/types/OfferType";
import {IVendorOffer} from "../../offer/types/VendorOffer";
import {isActiveVendorOffer} from "./is_active_vendor_offer";

export function getActiveVendorOffers(vendorOffers: IVendorOffer[]) {
    return vendorOffers.filter((offer) => offer.type !== OfferType.COMMERCIAL && isActiveVendorOffer(offer));
}
import {OfferType} from "../../offer/types/OfferType";
import {IVendorOffer} from "../../offer/types/VendorOffer";
import {isActiveVendorOffer} from "./is_active_vendor_offer";

export function getActiveVendorOffers(vendorOffers: IVendorOffer[]) {
    return vendorOffers.filter((offer) => offer.type !== OfferType.COMMERCIAL && isActiveVendorOffer(offer));
}
